import React from 'react';
import {
  Collection,
  Card,
  Flex,
  Text,
  Badge,
  Button,
  Loader
} from '@aws-amplify/ui-react';
import { getStatusBadgeVariation } from '../../utils/helpers';

const ProjectList = ({ projects, loading, onEdit, onDelete, onManageParticipants, onViewProject, onExportData }) => {
  if (loading) {
    return (
      <Flex justifyContent="center" padding="2rem">
        <Loader size="large" />
        <Text padding="0.5rem">Loading projects...</Text>
      </Flex>
    );
  }

  if (projects.length === 0) {
    return (
      <Card variation="outlined" padding="1.5rem" textAlign="center">
        <Text>No projects found. Create a new project to get started.</Text>
      </Card>
    );
  }

  const getStatusBadge = (status) => {
    return <Badge variation={getStatusBadgeVariation(status)}>{status}</Badge>;
  };

  return (
    <>
      {/* Build number removed - now only shown in main Dashboard */}
      
      <Collection
        items={projects}
        type="list"
        gap="1rem"
        wrap="nowrap"
        direction="column"
      >
        {(project) => (
          <Card key={project.projectId} variation="outlined" padding="1rem">
            <Flex direction="column" gap="0.5rem">
              <Flex justifyContent="space-between" alignItems="center">
                <Text fontWeight="bold" fontSize="1.1rem">{project.name}</Text>
                {getStatusBadge(project.status)}
              </Flex>
              
              <Text fontSize="0.9rem" color="gray">
                {project.description || 'No description provided'}
              </Text>
              
              <Flex gap="0.5rem" wrap="wrap">
                <Text fontSize="0.8rem">
                  <strong>Range:</strong> {project.minNumber || project.numberRange?.min} - {project.maxNumber || project.numberRange?.max}
                </Text>
                <Text fontSize="0.8rem">
                  <strong>Participants:</strong> {project.participants || 0}
                </Text>
                <Text fontSize="0.8rem">
                  <strong>Time Window:</strong> {project.selectionTimeWindow} hours
                </Text>
              </Flex>
              
              <Flex justifyContent="flex-end" gap="0.5rem" marginTop="0.5rem">
                <div className="dropdown">
                  <Button size="small" variation="link">
                    Actions ▼
                  </Button>
                  <div className="dropdown-content">
                    <button 
                      className="dropdown-item" 
                      role="menuitem" 
                      tabIndex="-1" 
                      onClick={() => onViewProject(project)}
                    >
                      View Details
                    </button>
                    <button 
                      className="dropdown-item" 
                      role="menuitem" 
                      tabIndex="-1" 
                      onClick={() => onEdit(project)}
                    >
                      Edit
                    </button>
                    <button 
                      className="dropdown-item" 
                      role="menuitem" 
                      tabIndex="-1" 
                      onClick={() => onManageParticipants(project)}
                    >
                      Manage Participants
                    </button>
                    <button 
                      className="dropdown-item" 
                      role="menuitem" 
                      tabIndex="-1" 
                      onClick={() => onExportData(project)}
                    >
                      Export Data
                    </button>
                    <button 
                      className="dropdown-item danger" 
                      role="menuitem" 
                      tabIndex="-1" 
                      onClick={() => {
                        if (window.confirm(`Are you sure you want to delete "${project.name}"?`)) {
                          onDelete(project.id || project.projectId);
                        }
                      }}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </Flex>
            </Flex>
          </Card>
        )}
      </Collection>
    </>
  );
};

export default ProjectList;
